import { useTrans } from '@/shared/hooks/useTranslation';
import { useScopeCrumbs } from '@/viewmodel/features/project/hooks/useScopeCrumbs';
import { authenticatedBreadcrumbs } from '@/viewmodel/features/project/mappers/scopeBreadcrumbs';
import type { BreadcrumbItem } from '@/viewmodel/shared/breadcrumbs';
import { useLocation } from 'react-router-dom';

export function useAuthenticatedBreadcrumbsViewModel(): BreadcrumbItem[] {
  const { t } = useTrans();
  const { pathname } = useLocation();
  return authenticatedBreadcrumbs(pathname, useScopeCrumbs(), t);
}
